module.exports = __webpack_public_path__ + "img/hyperx-pulsefire-fps-pro-preview.c2ec1097.png";